module.exports = __webpack_public_path__ + "img/d6.853e3af9.png";